import {_request, _requestForm} from "./api";

export const listSeason = (date) => {
    let params = date;
    return new Promise((resolve, reject) => {
        return _request({
            target: 'season', method: 'GET', params: params
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const currentSeason = () => {
    return new Promise((resolve, reject) => {
        return _request({
            target: 'season/current', method: 'GET'
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};